import {ButtonProps, CardProps, ChipProps, IconButtonProps, Skeleton, Typography, Unstable_Grid2 as Grid} from "@mui/material";
import React, {ReactNode} from "react";
import InfiniteScroll from "react-infinite-scroller";
import DataCard from "./data-card";
import {GetExportInfoFunc} from "../../../../packages/data-grid";


export interface DataCardsDataType {
    key: string | number;
}


export type DataCardsTopAction = (IconButtonProps & DataCardsDataType)

export type DataCardsTopActions = DataCardsTopAction[];
export type DataCardsTopActionsFunc<T extends DataCardsDataType> = (data: T) => DataCardsTopAction[];

export type _DataCardsTopActions<T extends DataCardsDataType> = DataCardsTopActions | DataCardsTopActionsFunc<T>;


export type DataCardsBottomAction = (ButtonProps & DataCardsDataType)

export type DataCardsBottomActions = DataCardsBottomAction[];
export type DataCardsBottomActionsFunc<T extends DataCardsDataType> = (data: T) => DataCardsBottomAction[];

export type _DataCardsBottomActions<T extends DataCardsDataType> = DataCardsBottomActions | DataCardsBottomActionsFunc<T>;

export interface DataCardsProperty<T extends DataCardsDataType> extends DataCardsDataType {
    propertyName: keyof T;
    hidden?: boolean;
    title: ReactNode | ((propertyValue: T[keyof T], data: T) => ReactNode),
    value: ReactNode | ((propertyValue: T[keyof T], data: T) => ReactNode),
    valueProps?: ChipProps | ((propertyValue: T[keyof T], data: T) => ChipProps);
}

export interface DataCardsProps<T extends DataCardsDataType> {
    getExportInfo?: GetExportInfoFunc,
    cardTopActions?: _DataCardsTopActions<T>,
    cardBottomActions?: _DataCardsBottomActions<T>,
    cardTitle?: ReactNode | ((data: T) => ReactNode),
    cardProps?: CardProps,
    cardProperties?: DataCardsProperty<T>[],
    cardChildren?: ReactNode | ((data: T) => ReactNode),
    data: T[],
    loading?: boolean,
    loadMoreData: VoidCallback,
    hasMoreToLoad: boolean,
    gridItemSizes?: {
        xs?: number,
        sm?: number,
        md?: number,
        lg?: number,
        xl?: number,
    }
}

const DataCards = <T extends DataCardsDataType>(props: DataCardsProps<T>) => {

    return (
        <>
            {/*@ts-ignore*/}
            <InfiniteScroll
                pageStart={0}
                loadMore={props.loadMoreData}
                hasMore={props.hasMoreToLoad}
                useWindow={false}
                getScrollParent={() => document.querySelector('main')}
                threshold={50}
            >
                <Grid container spacing={2}>
                    {
                        props.data.map(dataEntry => (
                            <Grid key={dataEntry.key} xs={12} md={6} xl={4} {...props.gridItemSizes ?? {}}>
                                <DataCard
                                    data={dataEntry}
                                    cardProps={props.cardProps}
                                    topActions={props.cardTopActions}
                                    bottomActions={props.cardBottomActions}
                                    title={props.cardTitle}
                                    properties={props.cardProperties}
                                    child={props.cardChildren}
                                />
                            </Grid>
                        ))
                    }
                    {
                        props.loading &&
                        Array.from({length: 12}).map((_, key) => (
                            <Grid key={`loading-${key}`} xs={12} md={6} xl={4}>
                                <Skeleton sx={{minHeight: 450,}}/>
                            </Grid>
                        ))
                    }
                </Grid>
                {
                    !props.loading && !props.data.length &&
                    <Typography variant={'body2'} width={'100%'} textAlign={'center'} marginBlock={10}>
                        No data found.
                    </Typography>
                }
            </InfiniteScroll>
        </>
    );
}

export * from './data-card';
export {default as DataCard} from './data-card';

export default DataCards;
